export const FILE_PREVIEW_TYPES = [
  { name: 'testFile.pdf', size: 3333, type: 'application/pdf' },
  { name: 'testFile.xsl', size: 3333, type: 'application/vnd.ms-excel' },
  { name: 'testFile.docx', size: 3334, type: 'application/msword' },
  {
    link: true,
    name: 'testFile.ppt',
    size: 3335,
    type: 'application/vnd.ms-powerpoint',
  },
  { name: 'testFile.pdf', size: 5333, type: 'video/mp4', uploading: true },
  {
    name: 'testFileWith Very VeryVeryLongName.JPG',
    size: 333,
    type: 'image/jpeg',
    uploading: true,
  },
  {
    name: 'testFileWith Very VeryVeryLongName.JPG',
    size: 333,
    type: 'application/vnd.ms-excel',
    uploading: true,
  },
  {
    error: { text: 'File error' },
    name: 'testFile.JPG',
    origin: [{ size: 3333333 }],
    type: 'image/jpeg',
    uploading: true,
  },
  {
    error: { text: 'File error' },
    name: 'testFile.pdf',
    origin: [{ size: 3333333 }],
    type: 'application/pdf',
  },
]
